module.exports = __webpack_public_path__ + "img/protocol-waiting-for-approval.a8e4191f.svg";